import PhoneInput from 'react-phone-number-input'

export default PhoneInput
